module.exports = __webpack_public_path__ + "img/antrego_video.6e909e7b.webp";